import {
    mapState,
    mapActions
} from 'vuex'
// import { Dialog } from 'vant'
export default {
    name: 'officialAccountsDialog',
    data () {
        return {
            showStatus: false,
            // message: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIyMTk0NzcyNw==&scene=110#wechat_redirect'
            message: '枫车养车'
        }
    },
    created () { },
    activated () { },
    mounted () { },
    methods: {
        ...mapActions(['getCarNoBelongTo']),
        onCopy (e) {
            this.$toast('复制成功')
        },
        open () {
            this.showStatus = true
        },
        close () {
            this.showStatus = false
        },
        // toOfficialAccounts () {
        //     location.href = this.message
        // }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin
        }),
        show () {
            return this.isWeixin
        }
    }
    // components: { Dialog }
}
